document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header');
  if (!header) return;

  let lastScrollY = window.scrollY;
  let ticking = false;

  const updateHeader = () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > 150) {
      if (!header.classList.contains('header--fixed')) {
        header.classList.add('header--fixed');
      }

      if (currentScrollY > lastScrollY + 10) {
        header.classList.add('header--hidden');
      } else if (currentScrollY < lastScrollY - 10) {
        header.classList.remove('header--hidden');
      }
    } else {
      header.classList.remove('header--fixed', 'header--hidden');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  });
});
